export const WEBPAGE_WARNING_LIMIT_MIN = 2;
